/*global $:false, Slick:false */

import down_gif from '@cob/ui-genesis/images/down.gif';

import { format as formatNumber } from '../fields/recordm.fields.number.js';
import { sprintf } from 'sprintf-js';

import tmpl_details_and_actions from '../templates/search-definition-result-action-dropdown.dot';
import tmpl_results from '../templates/search-definition-results.dot';
import tmpl_view_dropdown from '../templates/search-definition-view-dropdown.dot';
import tmpl_view_save from '../templates/search-definition-view-save.dot';

// $container: the jquery HTML wrapper for the enclosing element
//
// confs
//      * `rowsPerPage` : The size of the result (page size)
//      * `columns` : the grid columns
//      * `hideActionColumn` : (true|false) Wether we should hide the "Actions" column or not (defaults to false, which SHOWS the column)
//
// callbacks:
//      * executeInstanceAction(actionKey, instanceKey, instanceId): Execute the specific action on the instance result
//      * moreRecordsClick: called when the user asks for more search results
//      * columnsVisibilityChanged(columns, selectedResults): called when the user clicks on a view option checkbox or on one of the view options selection buttons.
//      * columnWidthChanged(fieldName, width): called when the user changes a columns's width by draging it to the desired width.
//      * columnOrderChanged(columns): called when the user drags some column(s), changing their order.
//      * saveCurrentView: called when the user clicks the "save view" button.
//      * viewNameConfirmed(name): called after the user inserts the new view name.
//      * deleteView(viewId): called when the user clicks on the "delete view" link.
//      * shareView(viewId): called when the user clicks on the "share view" link.
//      * unshareView(viewId): called when the user clicks on the "unshare view" link.
//      * activateView(viewId, viewLabel): called when the user selects a new view from the available views dropdown.
//      * selectAllViewOptionsRequested: called when the user clicks the "select all" button on the view options list.
//      * unselectAllViewOptionsRequested: called when the user clicks the "remove selection" button on the view options list.
//      * getFieldValue(resultData, fieldDef): called to get the value for each search result cell
//
const ImporterStatsSearchResultV = function(core, $container, confs, callbacks) {

    let _$grid,
        _$gridCanvas,
        _$totalRecordsLabel,
        _$massActionsContainer,
        _$emptyResultMsgContainer,
        _$actionsMsg,
        _$printBtn;

    let _visibleDataLength;

    let _allInstancesSelected = false;

    let _$viewSaveButton,
        _$viewStatus,
        _$activeView,
        _$viewDropdownList,
        _$viewSaveConfirmDialog,
        _$viewSaveName;

    let _slickgrid,
        _slickCheckboxSelector,
        _slickgridHeaderMenu,
        _slickSelectionModel,
        _printPlugin;

    const selectEntriesText = core.translateString("recordm.search", "select-entries-to-show-options"),
        noSelectableEntriesText = core.translateString("recordm.search", "no-entries-to-select"),
        noResultsText = core.translateString("recordm.search", "no-results"),
        nextRecordsText = core.translateString("recordm.search", "next_n_records"),
        detailsLinkText = core.translateString("recordm.search", "action.details-link");

    const headerMenus = {
        title: core.translateString("recordm.search", "headermenu.title"),
        "select-all": core.translateString("recordm.search", "headermenu.select-all"),
        "unselect-all": core.translateString("recordm.search", "headermenu.unselect-all"),
        "resize-columns": core.translateString("recordm.search", "headermenu.resize-columns"),
        "actions": core.translateString("recordm.search", "headermenu.actions")
    };

    const _viewMenuEntries = [
        {
            title: headerMenus.title,
            disabled: true
        },
        {
            title: headerMenus["select-all"],
            command: "all",
            contentClass: "select-all",
            isSelectable: false,
            iconCssClass: "icon-ok"
        },
        {
            title: headerMenus["unselect-all"],
            command: "none",
            contentClass: "remove-all",
            isSelectable: false,
            iconCssClass: "icon-remove"
        },
        {
            title: headerMenus["resize-columns"],
            command: "resize",
            contentClass: "resize-columns",
            isSelectable: false,
            iconCssClass: "icon-resize-horizontal"
        },
        {
            separator: true
        }
    ];

    const _emptyColumn = {
        id: "placebo",
        name: "",
        resizable: true,
        sortable: false,
        reordable: false
    };

    const _pageSize = confs.rowsPerPage;

    let _columns = confs.columns || { all: [], visible: [] },
        _totalResults = 0;

    const _slickGridOptions = {
        // Don't remove rowHeight prop because it is
        // required to calculate the height of the grid canvas.
        rowHeight: 25,
        explicitInitialization: true,
        enableCellNavigation: false,
        forceFitColumns: true,
        enableTextSelectionOnCells: true,
        autoHeight: confs.autoHeight || false,
        dataItemColumnValueExtractor: callbacks.getFieldValue,
        syncColumnCellResize: true,
        asyncPostRenderDelay: 0,
        enableAsyncPostRender: true,
        hideActionsColumn: (confs.hideActionsColumn === undefined ? false : confs.hideActionsColumn)
    };

    const _populateVariables = function() {
        _$grid = $(".grid", $container);
        _$totalRecordsLabel = $(".js-total-records", $container);
        _$emptyResultMsgContainer = $(".empty", $container);

        _$viewSaveButton = $(".js-view-save-button", $container);
        _$viewStatus = $(".js-view-status", $container);
        _$activeView = $(".js-active-view", $container);
        _$viewDropdownList = $(".js-view-dropdown-list", $container);

        _$massActionsContainer = $('.js-mass-actions', $container);

        _$actionsMsg = $('.js-actions-msg', _$massActionsContainer);
        _$printBtn = $('.js-print-btn', _$massActionsContainer);
    };

    const _getColumnsInSlickgridFormat = function() {

        var slickGridCols = [], // an array like [{ id: .., name: ..., field: ..., width: ... }, ...],
            thereAreResizableColumns = false;

        var headerMenuitems;

        // Place the checkbox column at the start
        var rowSelectionColumnDefinition = _slickCheckboxSelector.getColumnDefinition();
        rowSelectionColumnDefinition.reordable = false;

        slickGridCols.push(rowSelectionColumnDefinition);

        var sortedColumns = _columns.all
            .sort(function(col1, col2) {
                return col1.label.toLowerCase().localeCompare(col2.label.toLowerCase());

            }).filter(function(col) {
                return col.visibleInSearchResults;

            }).map(function(col) {
                col.visible = false;

                _columns.visible.forEach(function(visibleItem) {
                    if (visibleItem.fieldName === col.fieldName) {
                        col.visible = true;
                    }
                });

                thereAreResizableColumns = col.resizable || thereAreResizableColumns;

                return {
                    title: col.label,
                    command: col.fieldName,
                    isSelectable: true,
                    isChecked: col.visible
                };
            });

        headerMenuitems = _viewMenuEntries.concat(sortedColumns);

        slickGridCols = slickGridCols.concat(
            _columns.visible.map(_buildSlickGridColumnDefinitionObject)
        );

        //If there are no visible columns or
        //if all the visible columns are not resizable
        //we add an empty column to keep the grid width unchanged
        if (_columns.visible.length === 0 || !thereAreResizableColumns) {
            slickGridCols.push(_emptyColumn);
        }

        // Place the edit action column at the end
        if(!_slickGridOptions.hideActionsColumn){
            slickGridCols.push({
                id: "actions",
                name: headerMenus.actions,
                width: 85,
                minWidth: 100,
                maxWidth: 100,
                headerCssClass: "center-aligned",
                cssClass: "center-aligned entry-actions",
                reordable: false,
                formatter: function(row, cell, value, columnDef, dataContext) {
                    return tmpl_details_and_actions({
                            indexedInstanceM: callbacks.getStatM(dataContext.id),
                            actions: [],
                            detailsLinkText: detailsLinkText
                        }
                    )
                },
                printable:false
            });
        }

        //Place the column selection dropdown on the last header column (usually it's on the "Actions" header)
        slickGridCols[slickGridCols.length -1].header = {
            menu: {
                items: headerMenuitems,
                alignRight: true
            }
        };

        return slickGridCols;
    };

    const _buildSlickGridColumnDefinitionObject = function(col) {
        var columnDefinition = {
            id: col.fieldName,
            name: col.labelIcon ? col.labelIcon : col.label,
            field: col.fieldName,
            width: col.columnWidth,
            resizable: col.resizable,
            sortable: col.sortable,
            entityField: true,
            printable:col.printable
        };

        if (col.formatter && typeof col.formatter === 'function') {
            // no dataContext recebemos o doc ES completo
            columnDefinition.formatter = function(row, cell, value, columnDef, dataContext) {
                return col.formatter(value, dataContext, columnDef, core.getLocale());
            };
        }

        columnDefinition.headerCssClass = "center-aligned";

        if (col.align === 'center') {
            columnDefinition.cssClass = "center-aligned";

        } else if (col.align === 'right') {
            columnDefinition.cssClass = "right-aligned";
        } else {
            columnDefinition.cssClass = "left-aligned";
        }

        return columnDefinition;
    };

    const _initSlickgridPlugins = function() {
        _slickgridHeaderMenu = new Slick.Plugins.HeaderMenu({
           buttonImage: down_gif,
           cobAppInstanceId: core.getAppInstanceId()
        });

        _slickgridHeaderMenu.onCommand.subscribe(function(e, args) {

            var changedColumns = [];

            if (args.command === "resize") {

                _slickGridOptions.forceFitColumns = !_slickGridOptions.forceFitColumns;
                _slickgrid.setOptions(_slickGridOptions);


                // Reset the columns
                _slickgrid.setColumns(_getColumnsInSlickgridFormat());

                // Reset the selected rows since slickgrid doesn't do it itself
                _slickSelectionModel.setSelectedRows(_slickSelectionModel.getSelectedRows());

            } else{

                if (args.command === "all") {

                    _columns.all.forEach(function(column) {
                        changedColumns.push({fieldName: column.fieldName, visibility: true});
                    });

                    _updateMenuItemsSelection(true);

                } else if (args.command === "none") {

                    _columns.all.forEach(function(column) {
                        changedColumns.push({fieldName: column.fieldName, visibility: false});
                    });

                    _updateMenuItemsSelection(false);

                } else {

                    changedColumns.push({fieldName: args.command, visibility: args.item.isChecked});

                    _slickgridHeaderMenu.setMenuItemSelection(args.command, args.item.isChecked);
                }

                callbacks.columnsVisibilityChanged(changedColumns, _getSelectedResultsIds());
            }


        });

        _slickCheckboxSelector = new Slick.CheckboxSelectColumn({
            cssClass: "slick-cell-checkboxsel"
        });

        _printPlugin = new Slick.Plugins.Print();
    };

    const _buildSlickGrid = function() {

        _initSlickgridPlugins();

        _slickSelectionModel = new Slick.RowSelectionModel({
            selectActiveRow: false
        });

        _slickgrid = new Slick.Grid(_$grid, [], _getColumnsInSlickgridFormat(), _slickGridOptions);

        // Can only find the grid-canvas after slickgrid has been initialized
        _$gridCanvas = $(".grid-canvas", _$grid);

        _slickgrid.setSelectionModel(_slickSelectionModel);
        _slickgrid.registerPlugin(_slickCheckboxSelector);
        _slickgrid.registerPlugin(_slickgridHeaderMenu);
        _slickgrid.registerPlugin(_printPlugin);

        //expose the object so we can access it on custom js and access slickgrid events
        //https://stackoverflow.com/questions/5573806/is-there-a-way-to-get-an-instance-of-slickgrid-from-an-element
        _$grid.data("slickgridObject",_slickgrid);

    };

    const _buildViewDialogs = function() {
        _$viewSaveConfirmDialog = $(tmpl_view_save());

        _$viewSaveName = $('.js-view-name', _$viewSaveConfirmDialog);
    };

    const _buildViewDropdown = function(views) {
        _$viewDropdownList.empty();

        views.all.forEach(function(view) {
            _$viewDropdownList.append(tmpl_view_dropdown(view));
        });

        _addTooltipsToViewActions();
        _setActiveView(views.active);
    };

    const _prepareData = function(visibleData) {
        var addNoMatchFoundRow = (visibleData.length === 0);
        var addMoreRecordsRow = (!addNoMatchFoundRow && (visibleData.length < _totalResults));

        if (addNoMatchFoundRow) {
            visibleData.push({"nodata": true });
        }

        if (addMoreRecordsRow) {
            visibleData.push({"moreRecords": true });
        }
    };

    const _prepareRowStyling = function(visibleData) {

        visibleData.getItemMetadata = function(row) {

            if (visibleData[row].nodata) {
                return {
                    "cssClasses": "no-match-found-row",
                    "selectable": false,
                    "columns": {
                        0: {
                            colspan: "*",
                            formatter: function() {
                                return "<span class='no-match-found-text'>" + noResultsText + "</span>";
                            }
                        }
                    }
                };

            } else if (visibleData[row].moreRecords) {
                return {
                    "cssClasses": "more-records-row",
                    "selectable": false,
                    "columns": {
                        0: {
                            colspan: "*",
                            formatter: function() {
                                return "<span class='link more-records-text js-more-records'>"
                                           + sprintf(nextRecordsText, _pageSize) + "</span>";
                            }
                        }
                    }
                };

            } else if (visibleData[row].inactive) {
                return {
                    cssClasses: "inactive"
                };
            }

            return undefined;
        }
    };

    const _getCurrentSelectedRows = function() {
        var currentSelectedRows = _slickSelectionModel.getSelectedRows(),
            lastSelectedRow = _slickgrid.getDataItem(currentSelectedRows[currentSelectedRows.length - 1]);

        // Remove the last row if it's either the more records or the no data row
        // We do this because when selecting all rows on SlickGrid it silently selects those rows
        // even if they're set as not selectable
        if (lastSelectedRow && (lastSelectedRow.moreRecords || lastSelectedRow.nodata)) {
            currentSelectedRows.pop();
        }

        return currentSelectedRows;
    };

    const _getSelectedResultsIds = function() {
        var currentSelectedRows = _getCurrentSelectedRows(),
            selectedSearchResult = [],
            length = currentSelectedRows.length,
            i;

        for (i = 0; i < length; i++) {
            const entityId = _slickgrid.getDataItem(currentSelectedRows[i]).id;

            if(entityId !== undefined){
                selectedSearchResult.push(entityId);
            }
        }

        return selectedSearchResult;
    };

    const _setSelectedResults = function(resultsId) {
        var rows = _slickgrid.getData(),
            outLength = resultsId.length,
            inLength = rows.length,
            selectedRows = [],
            i, j;

        for (i = 0; i < outLength; i++) {
            for (j = 0; j < inLength; j++) {
                if (rows[j].id === resultsId[i]) {
                    selectedRows.push(j);
                }
            }
        }

        _slickSelectionModel.setSelectedRows(selectedRows);
    };

    const _selectAllResults = function() {
        var rows = [];
        for (var i = 0; i < _slickgrid.getDataLength(); i++) {
            rows.push(i);
        }
        _slickgrid.setSelectedRows(rows);
    };

    const _showData = function(visibleData) {

        var selectedResults;

        _visibleDataLength = (visibleData || []).length;

        if (_allInstancesSelected) {
            selectedResults = "all";

        } else {
            selectedResults = _getSelectedResultsIds();
        }

        _prepareData(visibleData);
        _prepareRowStyling(visibleData);

        _slickgrid.setData(visibleData);

        core.translate("recordm.search", _$gridCanvas);

        // The slickgrid is beeing initiated here because it has the property explicitInitialization set to 'true'.
        // It is necessary only when we are showing the grid for the first time, because in that process it will calculate
        // the width and height available for the component.
        // I couldn't find any problem in beeing executed on every request.
        _slickgrid.init();

        if (selectedResults !== "all") {
            _setSelectedResults(selectedResults);

        } else {
            _selectAllResults();
        }
    };

    const _showTotalMatchingRecords = function(total, exact) {
        _totalResults = total;
        _$totalRecordsLabel.text(formatNumber(total, false, undefined, core.getLocale()) + (exact ? '' : '+' ));

        if (_totalResults > 0) {
            _$actionsMsg.removeClass("none-pull-left");
            _$actionsMsg.text(selectEntriesText);

        } else {
            _$actionsMsg.addClass("none-pull-left");
            _$actionsMsg.text(noSelectableEntriesText);
        }
    };

    const _updateGridCanvasHeight = function() {
        var rowHeight = _slickGridOptions.rowHeight,
            heightRequired = _$gridCanvas.find(".slick-row").size() * rowHeight;

        // Add to the grid canvas height enough
        // that all dropdown menu options can be visible
        // in the last slickgrid row
        heightRequired += _$gridCanvas.find(".slick-row:not(.more-records-row):last")
            .find(".dropdown-menu").outerHeight();

        // Added 5px for the shadow
        heightRequired += 5;

        // update the grid canvas with the new height
        _$gridCanvas.height(heightRequired);
    };

    const _setViewStatus = function(text) {
        _$viewStatus.text(text).show();
        _$viewSaveButton.show();
    };

    const _resetViewStatus = function() {
        _$viewStatus.hide();
        _$viewSaveButton.hide();
    };

    const _showViewSaveDialog = function(name) {
        var $controlGroup = _$viewSaveName.parents('.js-control-group').first();

        $controlGroup.removeClass("error");
        $(".js-errormsg", $controlGroup).html("");

        _$viewSaveName.val(name);

        _$viewSaveConfirmDialog.modal({show: true, cobAppInstanceId: core.getAppInstanceId()});
        _$viewSaveName.focus();
    };

    const _setActiveView = function(activeView) {
        _$activeView.text(activeView.label || "Nenhuma");
    };

    const _changeViewSharingOption = function(viewId, isSharedView){
        var $view = $(".view-entry[data-viewId="+ viewId +"]", _$viewDropdownList),
            shareViewTooltip = core.translateString("recordm.search", "visualization.options.share"),
            unshareViewTooltip = core.translateString("recordm.search", "visualization.options.unshare"),
            $sharingBtn;

        if(isSharedView){
            $sharingBtn = $(".js-share-view", $view);

            $sharingBtn.addClass("js-unshare-view public-view");
            $sharingBtn.removeClass("js-share-view private-view");

            $sharingBtn.tooltip("destroy");
            $sharingBtn.tooltip({
                title: unshareViewTooltip,
                container:'#'+core.getAppInstanceId(),
                html:true
            });

        } else {
            $sharingBtn = $(".js-unshare-view", $view);

            $sharingBtn.addClass("js-share-view private-view");
            $sharingBtn.removeClass("js-unshare-view public-view");

            $sharingBtn.tooltip("destroy");
            $sharingBtn.tooltip({
                title: shareViewTooltip,
                container:'#'+core.getAppInstanceId(),
                html:true
            });
        }
    };

    const _addTooltipsToViewActions = function(){
        var deleteViewTooltip = core.translateString("recordm.search", "visualization.options.delete"),
            shareViewTooltip = core.translateString("recordm.search", "visualization.options.share"),
            unshareViewTooltip = core.translateString("recordm.search", "visualization.options.unshare");

        $(".js-delete-view", _$viewDropdownList).tooltip({
            title: deleteViewTooltip,
            container:'#'+core.getAppInstanceId()
        });

        $(".js-share-view", _$viewDropdownList).tooltip({
            title: shareViewTooltip,
            container:'#'+core.getAppInstanceId(),
            html:true
        });

        $(".js-unshare-view", _$viewDropdownList).tooltip({
            title: unshareViewTooltip,
            container:'#'+core.getAppInstanceId(),
            html:true
        });
    };

    const _updateMenuItemsSelection = function(selected) {
        var selectableMenuItems = _slickgridHeaderMenu.getSelectableItems(),
            menuItem;

        for (var i = 0; i < selectableMenuItems.length; i++) {
            menuItem = $(selectableMenuItems[i]);

            _slickgridHeaderMenu.setMenuItemSelection(menuItem.val(), selected);
        }
    };

    // listeners
    const _addListenerForInstanceActions = function() {
        _$gridCanvas.on('click', '.js-action', function(e) {
            e.preventDefault();

            /* eslint-disable-next-line no-invalid-this  */
            var $action = $(this);

            if (callbacks.executeInstanceAction) {
                callbacks.executeInstanceAction(
                    $action.data("action-key"),
                    $action.data("instancekey"),
                    $action.data("instanceid")
                );
            }
        });
    };

    const _addListenerToMoreRecordsRequest = function() {
        _$grid.on("click", ".js-more-records", callbacks.moreRecordsClick);
    };

    const _addListenerToSelectionChanged = function() {
        _slickSelectionModel.onSelectedRangesChanged.subscribe(function() {
            var numSelectedEntities = _getSelectedResultsIds().length;

            if(_totalResults > 0 && numSelectedEntities === _totalResults){
                _allInstancesSelected = true;
            } else if(numSelectedEntities < _visibleDataLength){
                _allInstancesSelected = false;
            }

            if (numSelectedEntities > 0) {
                _$printBtn.removeClass("hidden");
                _$actionsMsg.addClass("hidden");
            } else {
                _$printBtn.addClass("hidden");
                _$actionsMsg.removeClass("hidden");
            }

            if(callbacks.selectionChanged) callbacks.selectionChanged();
        });
    };

    const _addListenerToColumnsResized = function() {
        _slickgrid.onColumnsResized.subscribe(function() {

            var cols = _slickgrid.getColumns();

            cols.forEach(function(col) {
                if (col.previousWidth !== col.width) {
                    callbacks.columnWidthChanged(col.field, col.width);
                }
            });
        });
    };

    const _addListenerToColumnsReordered = function() {
        _slickgrid.onColumnsReordered.subscribe(function() {
            var cols = _slickgrid.getColumns(),
                columns = [];

            for (var i = 0; i < cols.length - 1; i++) {
                columns.push({
                    fieldName: cols[i].field
                });
            }

            callbacks.columnOrderChanged(columns);
        });
    };

    const _addListenerToColumnsSorted = function() {
        _slickgrid.onSort.subscribe(function(e, args) {
            callbacks.sortColumns(args.sortCol.field, args.sortAsc);
        });
    };

    const _resetColumnSort = function() {
        _slickgrid.setSortColumns([]);
    };

    const _addListenerToViewDropdown = function() {
        _$viewDropdownList.on('click', '.js-view-name-container', function(e) {
            e.preventDefault();

            /* eslint-disable-next-line no-invalid-this  */
            var element = $(this),
                viewId = element.parents("li").attr('data-viewId'),
                viewLabel = element.text();

            callbacks.activateView(viewId, viewLabel);
        });

        _$viewDropdownList.on('click', '.js-delete-view', function(e) {
            e.preventDefault();

            /* eslint-disable-next-line no-invalid-this  */
            var element = $(this);
            callbacks.deleteView(element.parents("li").attr('data-viewId'));
        });

        _$viewDropdownList.on('click', '.js-share-view', function(e) {
            e.preventDefault();

            //Dont propagate the event to keep the dropdown open
            e.stopPropagation();

            /* eslint-disable-next-line no-invalid-this  */
            var element = $(this);
            callbacks.shareView(element.parents("li").attr('data-viewId'));
        });

        _$viewDropdownList.on('click', '.js-unshare-view', function(e) {
            e.preventDefault();

            //Dont propagate the event to keep the dropdown open
            e.stopPropagation();

            /* eslint-disable-next-line no-invalid-this  */
            var element = $(this);
            callbacks.unshareView(element.parents("li").attr('data-viewId'));
        });
    };

    const _addListenerToViewSaveButton = function() {
        _$viewSaveButton.click(function(e) {
            e.preventDefault();

            callbacks.saveCurrentView();
        });
    };

    const _addListenerToSaveDialog = function() {
        var cb = function(e) {
            var viewName = _$viewSaveName.val(),
                $controlGroup = _$viewSaveName.parents('.js-control-group').first();

            e.preventDefault();

            if (viewName && viewName !== "") {
                callbacks.viewNameConfirmed(_$viewSaveName.val());

                //todo jone ver se um detach aqui corrige VisualizationsTest.vis_save_is_successfull
                _$viewSaveConfirmDialog.modal("hide");
            } else {
                $controlGroup.addClass("error");

                $(".js-errormsg", $controlGroup).html(
                    core.translateString("recordm.search", "visualization.name-cannot-be-empty")
                );
            }
        };

        $(".js-submit", _$viewSaveConfirmDialog).on('click', cb);
        $("form", _$viewSaveConfirmDialog).on('submit', cb);
    };

    // Throttle the resize event to avoid slowdowns
    const _onResize = $.throttle(function() {
        _slickgrid.resizeCanvas();
    }, 100);

    (function init() {
        var $html = $(tmpl_results({
            canPrint: false,
            canCreate: false,
            canImport: false
        }));

        core.translate("recordm.search", $html);

        $container.html($html);

        _populateVariables();

        _buildSlickGrid();
        _buildViewDialogs();

        _addListenerForInstanceActions();

        _addListenerToMoreRecordsRequest();
        _addListenerToSelectionChanged();
        _addListenerToColumnsResized();
        _addListenerToColumnsReordered();
        _addListenerToColumnsSorted();

        _addListenerToViewDropdown();
        _addListenerToViewSaveButton();
        _addListenerToSaveDialog();

        _$printBtn.on('click', function () {
            var css = Array.prototype.slice.call(window.document.getElementsByTagName("link"))
                .filter(function(el) {
                    return el.rel === 'stylesheet' &&
                           (el.href.indexOf('cob-') !== -1 ||
                            el.href.indexOf('recordm-') !== -1 ||
                            el.href.indexOf('localresource') !== -1)

                })
                .map(function(link){return  $('<div>').append($(link).clone()).html();})
                .join(' ');

            _printPlugin.print({
                triggerPrintDialog: true,
                cssLinksHtml: css,
                title: callbacks.getName(),
                selectedOnly:true
            });
        });

    })();

    return {
        start: function() {
            $(window).on('resize', _onResize);
            _slickgrid.resizeCanvas();
        },
        stop: function() {
            $(window).off('resize', _onResize);
        },
        setTotalMatchingResults: function(total, exact) {
            _showTotalMatchingRecords(total, exact);
        },
        setColumns: function(columns) {
            _columns = columns;

            // Reset the columns
            _slickgrid.setColumns(_getColumnsInSlickgridFormat());

            if (columns.sort) {
                _slickgrid.setSortColumn(columns.sort.column, columns.sort.ascending);

            } else {
                _slickgrid.setSortColumns([]);
            }

            // Reset the selected rows since slickgrid doesn't do it itself
           const selected = _slickSelectionModel.getSelectedRows();
           if( selected.length > 0) _slickSelectionModel.setSelectedRows(selected);
        },
        setSortColumn: function(fieldName, asc) {
            _slickgrid.setSortColumn(fieldName, asc || false);
        },
        setViewList: _buildViewDropdown,
        setViewStatus: _setViewStatus,
        resetViewStatus: _resetViewStatus,
        askForViewName: _showViewSaveDialog,
        setActiveView: _setActiveView,
        removeView: function(viewId) {
            _$viewDropdownList.find(".view-entry[data-viewId='" + viewId + "']").remove();
        },
        changeViewShareOption: _changeViewSharingOption,
        resetView: function() {
            _slickgrid.setData([]);
            _slickSelectionModel.setSelectedRows([]);
            _slickgrid.init();
            _slickgrid.render();
            _totalResults = 0;
            _$totalRecordsLabel.text("--");
            _resetColumnSort();
        },
        showWatermark: function() {
            _$emptyResultMsgContainer.show();
        },
        getSelectedResultsIds: _getSelectedResultsIds,
        setSearchInProgressMode: function() {
            _slickgrid.setData([]);
        },
        showData: function(data) {
            _$emptyResultMsgContainer.hide();

            _showData(data);
            _slickgrid.resizeCanvas();

            _updateGridCanvasHeight();
        },
        refreshGrid: function() {
            //hack para obrigar a grid a ser mostrada completamente qd se vem do editar/visualizar
            _slickgrid.resizeCanvas();
            _slickgrid.scrollRowIntoView(0);
        }
    };
};

export default ImporterStatsSearchResultV;
